var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "scrollbar-inner" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("h4", { staticClass: "h3 mb-0 title" }, [
            _vm._v("Timesheet Entry"),
          ]),
        ]),
        _c(
          "div",
          {
            staticClass:
              "card-body border border-bottom-0 border-right-0 border-left-0 timer-block",
          },
          [
            _c("div", { staticClass: "timer-block__timer" }, [
              _c("form", { attrs: { action: "" } }, [
                _c("div", { staticClass: "row align-items-center" }, [
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "form-group mb-3" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form-control-label",
                          attrs: { for: "example-time-input-start" },
                        },
                        [_vm._v("Start Time:")]
                      ),
                      _c("input", {
                        staticClass: "form-control form-control-sm",
                        attrs: {
                          type: "time",
                          value: "08:30:00",
                          id: "example-time-input-start",
                        },
                      }),
                    ]),
                  ]),
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "form-group mb-3" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form-control-label",
                          attrs: { for: "example-time-input-end" },
                        },
                        [_vm._v("End Time:")]
                      ),
                      _c("input", {
                        staticClass: "form-control form-control-sm",
                        attrs: {
                          type: "time",
                          value: "11:30:00",
                          id: "example-time-input-end",
                        },
                      }),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "row align-items-center" }, [
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "form-group mb-1" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form-control-label",
                          attrs: { for: "example-number-input-hours" },
                        },
                        [_vm._v("Hours:")]
                      ),
                      _c(
                        "select",
                        {
                          staticClass: "form-control form-control-sm",
                          attrs: { id: "exampleFormControlSelect1" },
                        },
                        [
                          _c("option", [_vm._v("1")]),
                          _c("option", [_vm._v("2")]),
                          _c("option", [_vm._v("3")]),
                          _c("option", [_vm._v("4")]),
                          _c("option", [_vm._v("5")]),
                          _c("option", [_vm._v("6")]),
                          _c("option", [_vm._v("7")]),
                          _c("option", [_vm._v("8")]),
                          _c("option", [_vm._v("9")]),
                          _c("option", [_vm._v("10")]),
                          _c("option", [_vm._v("11")]),
                          _c("option", [_vm._v("12")]),
                          _c("option", [_vm._v("13")]),
                          _c("option", [_vm._v("14")]),
                          _c("option", [_vm._v("15")]),
                          _c("option", [_vm._v("16")]),
                          _c("option", [_vm._v("17")]),
                          _c("option", [_vm._v("18")]),
                          _c("option", [_vm._v("19")]),
                          _c("option", [_vm._v("20")]),
                          _c("option", [_vm._v("21")]),
                          _c("option", [_vm._v("22")]),
                          _c("option", [_vm._v("23")]),
                          _c("option", [_vm._v("24")]),
                        ]
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "form-group mb-1" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form-control-label",
                          attrs: { for: "example-number-input-hours" },
                        },
                        [_vm._v("Minutes:")]
                      ),
                      _c("input", {
                        staticClass: "form-control form-control-sm",
                        attrs: {
                          type: "number",
                          value: "23",
                          id: "example-number-input-hours",
                        },
                      }),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "form-group mt-3" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form-control-label mb-3",
                          attrs: { for: "exampleFormControlTextarea1" },
                        },
                        [
                          _vm._v(
                            "\n                  Work completed on this\n                  task\n                "
                          ),
                        ]
                      ),
                      _c("textarea", {
                        staticClass: "form-control",
                        attrs: { id: "exampleFormControlTextarea1", rows: "3" },
                      }),
                    ]),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-success btn-lg btn-block",
                        attrs: { type: "button" },
                      },
                      [_vm._v("Submit")]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }